/**
 * An empty module used as a stub target for 'turbopack.resolveAlias' whenever a package must
 * resolve to nothing. Two cases use it: a server-only package that must be kept out of the browser
 * bundle, and an unmet optional peer dependency that is referenced behind a runtime guard and never
 * actually executed.
 *
 * The 'pino-pretty' package (and its transitive 'sonic-boom' and 'pino-abstract-transport'
 * dependencies) rely on Node built-ins such as 'fs', 'worker_threads' and 'stream' that cannot be
 * resolved for the browser.  It is only required at runtime on the server, so the browser bundle
 * aliases it to this empty module via 'turbopack.resolveAlias'.  This mirrors the previous webpack
 * 'resolve.fallback' behavior.
 *
 * The 'superagent-proxy' package is an unmet peer dependency of the Auth0 v3 SDK's 'rest-facade'
 * that is only 'require()'d when an HTTP proxy is configured (this app never configures one), so it
 * is not installed.  Aliasing it here lets the server build resolve the otherwise-absent module.
 */
export {};
